import BSNavbar from "../../component/Navbar/Navbar";
import { motion } from "framer-motion";

const ChiChat = () => {
  return (
    <div style={{ width: "100%" }}>
      <BSNavbar />
      <motion.h2
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 0.2 }}
        className="mt-4"
        style={{ textAlign: "center" }}
      >
        專屬於交大、清大與政大的交友軟體。
      </motion.h2>
      <motion.h2
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1.2 }}
        className="mt-3"
        style={{ textAlign: "center" }}
      >
        馬上掃描 QRCode 加入！
      </motion.h2>
      <div
        className="ms-auto me-auto mt-5"
        style={{
          width: "60%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "10vw",
        }}
      >
        <img
          src="example.jpg"
          style={{
            height: "60vh",
            border: "10px solid black",
            borderRadius: "20px",
          }}
        />
        <img src="oa-qrcode.png" style={{ height: "40vh" }} />
      </div>
    </div>
  );
};

export default ChiChat;
